/* eslint-disable func-names */
import * as Yup from "yup";
import { IItbi } from "../../../../../../shared/providers/itbi/interfaces";

const itbiSchema = Yup.object().shape({
    setor: Yup.string().required("Campo SETOR é obrigatório"),
    quadra: Yup.string().required("Campo QUADRA é obrigatório"),
    lote: Yup.string().required("Campo LOTE é obrigatório"),
    tipoimovel: Yup.string().required("Campo TIPO DO IMÓVEL é obrigatório"),

    // Validação cruzada entre valor e basecalculo
    valor: Yup.string().test(
        "valor-basecalculo",
        "Os campos VALOR e BASE DE CÁLCULO são obrigatórios entre si",
        function (value) {
            const { basecalculo } = this.parent;
            return Boolean(value) === Boolean(basecalculo); // Ambos devem ser preenchidos ou vazios
        }
    ),

    basecalculo: Yup.string().test(
        "basecalculo-valor",
        "Os campos VALOR e BASE DE CÁLCULO são obrigatórios entre si",
        function (value) {
            const { valor } = this.parent;
            return Boolean(value) === Boolean(valor);
        }
    ),

    // Validação cruzada entre valorfinanciado e basecalculofinanciado
    valorfinanciado: Yup.string().test(
        "valorfinanciado-basecalculofinanciado",
        "Os campos VALOR (FINANCIADO) e BASE DE CÁLCULO (FINANCIADO) são obrigatórios entre si",
        function (value) {
            const { basecalculofinanciado } = this.parent;
            return Boolean(value) === Boolean(basecalculofinanciado);
        }
    ),

    basecalculofinanciado: Yup.string().test(
        "basecalculofinanciado-valorfinanciado",
        "Os campos VALOR (FINANCIADO) e BASE DE CÁLCULO (FINANCIADO) são obrigatórios entre si",
        function (value) {
            const { valorfinanciado } = this.parent;
            return Boolean(value) === Boolean(valorfinanciado);
        }
    ),
});

export const itbiValidator = async (payload: IItbi) => {
    await itbiSchema.validate(payload, { abortEarly: false });
};
